import { Container, Row, Col } from "react-bootstrap";

const About = () => {
  return (
    <div>
      <Container>
        <Row>
          <Col>
            <div className="tentang-judul">aboutMe.</div>
            <div className="tentang-isi">
              My name is Farhan Hafizh I am a Front End Engineer and UI & UX
              Designer based in Tangerang. I describe myself as a passionate
              developer who loves coding, open source and web platforms.
            </div>
          </Col>
        </Row>
      </Container>
      <Container>
        <Row>
          <Col>
            <div className="bawah-judul">freeSpace.</div>
            <a
              className="social-media"
              href="https://www.instagram.com/freespace_id/"
              target="_blank"
            >
              instagram
            </a>
            <a
              className="social-media"
              href="https://github.com/hanhafizh"
              target="_blank"
            >
              github
            </a>
            {/* <a className="social-media" href="https://www.instagram.com/freespace_id/" target="_blank">discord</a> */}
            <h1 className="copyright">@2022 freeSpace</h1>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default About;
